import React, { forwardRef, useRef, useEffect } from 'react';
import ThumbnailItem from './ThumbnailItem/ThumbnailItem';

const ThumbnailSlider = forwardRef(({
  currentIndex,
  onClick,
  images,
  onImageError,
  onImageLoad,
  tmntData,
}, ref) => {
  const keyDownTimeoutRef = useRef(null);

  useEffect(() => () => {
    if (keyDownTimeoutRef.current) {
      clearTimeout(keyDownTimeoutRef.current);
    }
  }, []);

  const handleKeyDown = (event) => {
    const { key } = event;
    let newIndex = currentIndex;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      event.preventDefault();
      newIndex = Math.min(currentIndex + 1, images.length - 1);
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      event.preventDefault();
      newIndex = Math.max(currentIndex - 1, 0);
    } else if (key === 'Home') {
      event.preventDefault();
      newIndex = 0;
    } else if (key === 'End') {
      event.preventDefault();
      newIndex = images.length - 1;
    } else if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      onClick?.(currentIndex);
      return;
    }

    if (newIndex !== currentIndex) {
      onClick?.(newIndex);

      if (keyDownTimeoutRef.current) {
        clearTimeout(keyDownTimeoutRef.current);
      }

      keyDownTimeoutRef.current = setTimeout(() => {
        const newThumbnail = document.querySelector(`#pdp-thumbnail-${newIndex}`);
        newThumbnail?.focus();
        keyDownTimeoutRef.current = null;
      }, 1);
    }
  };

  return (
    <div className="thumbnail-slider-container">
      <ul
        className="thumbnail-slider-container__wrapper"
        ref={ref}
        role="tablist"
        aria-label={tmntData?.altImagesThumbContainerLabel?.value}
      >
        {images?.map((image, index) => (
          <ThumbnailItem
            key={image.imageId || `thumbnail-${index}`}
            image={image}
            index={index}
            isSelected={index === currentIndex}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            onImageError={onImageError}
            onImageLoad={onImageLoad}
            tmntData={tmntData}
            totalImages={images.length}
          />
        ))}
      </ul>
    </div>
  );
});

ThumbnailSlider.displayName = 'ThumbnailSlider';

export default ThumbnailSlider;
